<div
    class="flex min-w-0 items-center justify-start gap-2 max-md:flex-wrap [grid-area:start]"
>
    <ng-content select="[previewToolbarStart]" />
</div>

<div
    preview-toolbar-center
    class="flex min-w-0 items-center justify-center gap-2"
>
    <ng-content select="[previewToolbarCenter]" />
</div>

<div
    class="flex min-w-0 items-center justify-end gap-2 max-md:flex-wrap [grid-area:end]"
>
    <ng-content select="[previewToolbarEnd]" />
</div>
